import SingleFieldEditor from "./SingleFieldEditor";

type MultiFieldEditorProps = {
  fields: {
    [key: string]: string;
  };
  onEditKey?: (oldFieldId: string, newFieldId: string) => void;
  onEditValue: (fieldId: string, fieldValue: string) => void;
  onRemoveField: (fieldId: string) => void;
};

export const MultiFieldEditor = (props: MultiFieldEditorProps) => {
  return (
    <table>
      <tbody>
        {Object.keys(props.fields).map((fieldId) => {
          const fieldValue = props.fields[fieldId];
          return (
            <SingleFieldEditor
              key={fieldId}
              fieldId={fieldId}
              fieldValue={fieldValue}
              onEditKey={props.onEditKey}
              onEditValue={props.onEditValue}
              onRemoveField={props.onRemoveField}
            />
          );
        })}
      </tbody>
    </table>
  );
};
